import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass, Style, textEllipsis } from '../../../style';


const cssPrefix = 'CardViewDetailsTooltip';

export namespace DetailsTooltipStyles {

  export const Width = 320;

  export const DetailsTooltip = cssClass(cssPrefix, 'details-tooltip', {
    width: Width,
    paddingTop: 6,
    lineHeight: '14px',
    fontFamily: CommonStyles.Fonts.HeaderFont,
    fontSize: '12px',
    color: TabStyles.Typography.Color.Primary,
  });

  export const EntityName = cssClass(cssPrefix, 'entity-name', {
    fontFamily: CommonStyles.Fonts.HeavyFont,
    fontSize: '14px',
    maxHeight: '1.5em * 5',
    wordWrap: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: TabStyles.Spacing.LargeSpace
  });

  export const MetadataSection = cssClass(cssPrefix, 'metadata-section', textEllipsis, {
    marginBottom: TabStyles.Spacing.LargeSpace,
    $nest: {
      '&:last-of-type': {
        marginBottom: 0
      }
    }
  });

  export const MetadataSectionWithContentDescription = cssClass(cssPrefix, 'metadata-content-description-section', {
    marginBottom: TabStyles.Spacing.ExtraLargeSpace
  });

  export const MetadataSectionWithCertifierDetails = cssClass(cssPrefix, 'metadata-certifier-details-section', {
    marginTop: TabStyles.Spacing.LargeSpace
  });

  export const MetadataTitle = cssClass(cssPrefix, 'metadata-title', {
    fontFamily: CommonStyles.Fonts.HeavyFont
  });

  export const MultiLineTitle = cssClass(cssPrefix, 'metadata-multiline-title', {
    fontFamily: CommonStyles.Fonts.HeavyFont,
    marginBottom: TabStyles.Spacing.MediumSpace
  });

  export const MetadataRelatedTitle = cssClass(cssPrefix, 'metadata-list-title', {
    fontFamily: CommonStyles.Fonts.HeavyFont,
    lineHeight: '20px'
  });

  export const ContentTypeIcon = cssClass(cssPrefix, 'content-type-icon', {
    height: '100%',
    marginRight: 6,
    verticalAlign: 'top',
  });

  export const MetadataValue = cssClass(cssPrefix, 'metadata-value', {
    marginLeft: TabStyles.Spacing.MediumSpace
  });

  export const metadataLineHeight = 20;

  export const MetadataLinkValue = cssClass(cssPrefix, 'metadata-link-value',{
    marginLeft: TabStyles.Spacing.MediumSpace,
    lineHeight: metadataLineHeight + 'px'
  });

  export const MetadataLinks = cssClass(cssPrefix, 'metadata-value', {
    display: 'inline-block',
    marginRight: TabStyles.Spacing.DefaultSpace
  });

  const MetadataValueMultilineStyle: Style = {
    whiteSpace: 'normal',
    lineHeight: '1.5em',
  };

  const MetadataTextMultilineStyle: Style = {
    ...MetadataValueMultilineStyle,
    marginTop: TabStyles.Spacing.DefaultSpace,
  };

  const MetadataLinksMultilineStyle: Style = {
    ...MetadataValueMultilineStyle,
    marginTop: TabStyles.Spacing.MediumSpace,
  };

  export const MetadataValueContentDescription = cssClass(cssPrefix, 'metadata-content-description',
    MetadataValueMultilineStyle);

  export const MetadataTextDescription = cssClass(cssPrefix, 'metadata-text-description',
    MetadataTextMultilineStyle);

  export const MetadataLinksDescription = cssClass(cssPrefix, 'metadata-links-description',
    MetadataLinksMultilineStyle);
}
